module.exports = __webpack_public_path__ + "static/media/sucess_order_delivery.e06882ee.svg";